type QueuedCsa = ((...args: unknown[]) => void) & { q?: IArguments[]; t?: number };

export const installRaasCsaStub = (win: Window = window): void => {
  const w = win as Window & { _raasCsa?: QueuedCsa };
  if (w._raasCsa) return;
  (function (g: Window, o: string) {
    const gw = g as unknown as Record<string, QueuedCsa>;
    gw[o] =
      gw[o] ||
      function () {
        (gw[o].q = gw[o].q || []).push(arguments);
      };
    gw[o].t = Date.now();
  })(win, "_raasCsa");
};

type RaasCsaImpl = (
  command: string,
  page: unknown,
  ...blocks: unknown[]
) => void | Promise<void>;

/** Swap stub for `impl` and replay queued `_raasCsa(...)` calls. */
export const replaceRaasCsaAndDrain = (impl: RaasCsaImpl): void => {
  if (typeof window === "undefined") return;

  installRaasCsaStub(window);

  const w = window as Window & { _raasCsa?: QueuedCsa };
  const prev = w._raasCsa;
  if (!prev) return;

  const queue = [...(prev.q ?? [])];
  if (prev.q) prev.q.length = 0;

  const next: QueuedCsa = function (...args: unknown[]) {
    const [command, page, ...blocks] = args;
    void Promise.resolve(
      impl(command as string, page, ...(blocks as unknown[])),
    );
  };
  next.t = prev.t;
  w._raasCsa = next;

  for (const args of queue) {
    const arr = Array.from(args as ArrayLike<unknown>);
    const [command, page, ...blocks] = arr;
    void Promise.resolve(
      impl(command as string, page, ...(blocks as unknown[])),
    );
  }
};
